module.exports = __webpack_public_path__ + "img/112016.d95ee704.png";